import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))


export default {
    namespaced: true,
    state: {
        ...filtersCopy,
    },
    mutations: {
        setBrands(state, brands) {
            state.brands = brands
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        getSubscriptionCharges({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/subscription-charge?page=${page}&${query}`)
            return req
        },
        getSubscriptionChargeHistory({commit, state}, form) {
            let req = axios.get(`/subscription-charge-log/subscription-charge/${form.subscription_charge_id}?page=${form.page}`)
            return req
        },
        chargeSubscription({commit, state}, form) {
            let req = axios.post(`/change/subscription-charge/subscription-charge/${form.subscription_charge_id}`, form)
            return req
        },
        manuallyChargeSubscription({commit, state}, form) {
            let req = axios.get(`/subscription-charge/manual/charge/user/${form.user_id}/product/${form.product_id}`)
            return req
        },
        deleteSubscriptionCharges({commit, state}, form) {
            let req = axios.delete(`/subscription-charge/${form.id}`)
            return req
        },
        subscriptionChargeFilterable({commit, state}, page) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/filterable/subscription-charge?page=${page}&${query}`)
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}